<h5 mat-dialog-title>Preview Letter</h5>

<mat-dialog-content>
    <div class="letter" [innerHTML]="letter.letterHTML">
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">Close</button>
</mat-dialog-actions>